export const SejamKeys = {
  sendOtp: 'sejam-send-otp',
  verifyOtp: 'sejam-verify-otp',
}
